import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { map } from "rxjs/operators";
import { UrlConstants } from "src/app/models/urlConstants";
import { Account } from "src/app/screens/user-profile/client-data";
import { ApiService } from "src/app/services/api.service";
import {ClientInvoicesFilterModel } from "src/app/models/clientInvoices"

@Component({
  selector: "app-invoices-modal",
  templateUrl: "./invoices-modal.component.html",
  styleUrls: ["./invoices-modal.component.scss"],
})
export class InvoicesModalComponent implements OnInit {
  today = new Date();
  selectedInvoice: any;
  invoices: any[];
  dateFrom: Date = new Date(this.today.setDate(this.today.getDate() - 3));
  dateTo: Date = new Date();
  selectedClient: any;
  accList: Object;
  isReportArabic: boolean = true
  isInvoicesLoading = false;
  inputUser: Account;
  mainCode:number;
  subCode:number;
  filter:ClientInvoicesFilterModel 
  isArabic:boolean

  tryGenerate(invoice) {
  let filter = {
      invoiceIDs: [invoice.InvoiceID],
      invoiceType: "invoices",
      isArabic: this.isReportArabic,
      take: 1
    }

    localStorage.setItem('reportFilter', JSON.stringify(filter))
    const url = this.router.serializeUrl(this.router.createUrlTree(['/generic-report/' + 'RptInvoice' + '/' + '0'], { queryParams: { hideNavbar: true } }))
    window.open(url, '_blank')
  }

  selectInvoice(invoicee) {
    this.selectedInvoice = invoicee;
  }

  constructor(
    private http: HttpClient,
    public activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    private apiService: ApiService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {
    this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];

    if (this.data != null && this.data["inputUser"] != null) {
      {
        this.selectedClient = this.data["inputUser"];
         this.mainCode=this.data['inputUser'].MainCode
        this.subCode=this.data['inputUser'].SubCode
        this.onDateChange();
      }
    }
    this.isArabic =this.translate.currentLang === "ar";
  }

  fetchClientInvoices() {
    let from = moment(this.dateFrom).format("YYYY/MM/DD");
    let to = moment(this.dateTo).format("YYYY/MM/DD");
     this.filter={
      mainCode:this.mainCode,
      subCode:this.subCode,
      from:this.dateFrom,
      to:this.dateTo,
      relationCode:this.selectedClient,
      isPosted:true
    } 
    // 01-03-2020
    return this.http.post<any[]>(
      `${UrlConstants.backofficeUrl}/api/Invoice/getClientInvoices`,this.filter
    );
  }

  onSelectClient(event) {}

  onDateChange() {
    this.isInvoicesLoading = true;
    this.fetchClientInvoices().subscribe((res) => {
      this.invoices = res;
      this.isInvoicesLoading = false;
    });
  }
public maxDate: Date = new Date();
  fetchDefaultAccount()
  {
        this.accList = JSON.parse(localStorage.getItem("accList")) as Account[];
        this.selectedClient = this.accList[0].relationCode;
        this.mainCode = this.accList[0].MainCode;
        this.subCode = this.accList[0].SubCode;
  }
  public disableFutureDates = (d: Date | null): boolean => {
    if (!d) return true;
    const today = new Date();
    const date = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const max = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    return date <= max;
  };
  ngOnInit(): void {
    this.activatedRoute.paramMap
      .pipe(map(() => window.history.state))
      .subscribe((res) => {
        if (res.user != null) {
          this.inputUser = res.user;
          this.selectedClient = this.inputUser.relationCode;
          this.onDateChange();
        }
      });
      this.fetchDefaultAccount();

  }
}
